export default class OutboundLinks {
  constructor() {
    for(var l = 0, links = document.querySelectorAll('a'), ll = links.length; l < ll; ++l) {
       var url = links[l].getAttribute('href');

       if(!url) {
         continue;
       }

       var host = window.location.hostname.toLowerCase();
       var regex = new RegExp('^(?:(?:f|ht)tp(?:s)?\:)?//(?:[^\@]+\@)?([^:/]+)', 'im');
       var match = url.match(regex);
       var domain = ((match ? match[1].toString() : ((url.indexOf(':') < 0) ? host : ''))).toLowerCase();

       // Same domain
       if(domain != host) {
         links[l].setAttribute('target', '_blank');
         if(links[l].getAttribute('title')) {
           links[l].setAttribute('title', links[l].getAttribute('title') + " (Opens in a new tab)");
         } else {
           links[l].setAttribute('title', "(Opens in a new tab)");
         }

         // Check if the current link is inside of open-content to add --external class
         if (links[l].closest('.open-content')) {
          links[l].classList.add('--external');
         }
       }
    }
  }
}
